<template>
  <div class="overflow-auto mb-16 px-2">
    <div>
      <div
        v-if="courseWorkId"
        class="flex items-center bg-gray-50 px-5 py-2.5 mb-3"
      >
        <div class="text-gray-500 leading-5 w-11/12">
          <p>
            You can only connect the RoundTable to one LMS assignment at a time.
          </p>
          <p>To change LMS assingment you need to disconnect this one.</p>
        </div>
        <button
          @click="disconnectIntegration"
          class="px-8 py-2 h-9 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50"
        >
          Disconnect
        </button>
      </div>
      <div class="font-semibold text-lg">
        {{ header }}
      </div>
      <div class="flex flex-row items-center text-gray-500 text-sm">
        <img :src="logo" height="25px" width="25px" class="mr-2 rounded-full" />
        <div v-if="!edLink">
          {{ getCourseDetail.google_classroom_integration.course_name }}
        </div>
        <div v-else>{{ integration.course_name }}</div>
      </div>
    </div>
    <div class="py-4">
      <template v-if="selected_tab === 'create_assignment_tab'">
        <div class="flex flex-col">
          <input
            v-model="title"
            placeholder="Roundtable Name"
            class="w-full px-4 py-2 mb-3 bg-input rounded text-gray-500"
            :style="title.trim().length === 0 ? 'border-color:red' : ''"
          />
          <div
            class="rounded text-md text-gray-500 focus-within:border-primary border border-solid border-input"
          >
            <textarea
              v-model="description"
              placeholder="Description"
              class="resize-none w-full focus:outline-none bg-input overflow-auto px-4 py-2 rounded"
              rows="5"
            />
            <div class="flex items-center bg-input rounded px-4 -mt-3 pb-3">
              <i class="fa-solid text-lg mr-3 fa-circle-info"></i>
              <div v-html="link_to_RT_html" />
            </div>
          </div>
          <div class="flex flex-row gap-3 mt-4">
            <div
              v-if="schoology_categories.length"
              class="flex flex-col w-6/12"
            >
              <span class="font-semibold"> Assignment Category </span>
              <pl-select
                :options="schoology_categories"
                :selected="schoology_category"
                label="name"
                :arrow="true"
                placeholder="Select a category"
                @change="schoology_category = $event"
                class="mt-2 bg-gray-50 rounded text-gray-500"
              >
              </pl-select>
            </div>
            <div class="flex flex-col justify-between">
              <span class="font-semibold"> Due Date </span>
              <div
                class="mt-2 py-2 px-4 bg-input rounded border-0 outline-none"
              >
                <flat-pickr
                  class="border-none bg-input border-0 border-input"
                  v-model="date"
                  :config="config"
                  placeholder="Select a date"
                >
                </flat-pickr>
                <a class="cursor-pointer" data-toggle>
                  <i class="fas fa-calendar-alt text-gray-400"></i>
                </a>
              </div>
            </div>
            <div class="flex flex-col w-2/12">
              <div class="font-semibold">Max Score</div>
              <input
                @input="inputed"
                v-model="maxPoints"
                class="mt-2 px-4 py-2 bg-input rounded text-sm text-gray-500 w-full"
                :style="max_points_error ? 'border-color:red' : ''"
              />
              <span
                style="white-space: pre-line"
                v-if="max_points_error"
                v-html="max_points_error_message"
              ></span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="courseWorkId">
          <!-- Students Content -->
          <div class="grid grid-cols-2 gap-x-3">
            <div class="flex flex-col">
              <p class="text-base text-black">Available</p>
              <div
                class="w-full h-80 p-3 border border-gray-100 rounded overflow-auto"
              >
                <div class="mb-2 bg-white border rounded border-gray-100">
                  <input
                    v-model="search_string_available"
                    class="p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input"
                    type="text"
                    placeholder="Search..."
                  />
                </div>
                <div v-if="students_to_import.length" class="flex flex-nowrap">
                  <pl-checkbox
                    @change="handleSelectAllAvailable($event)"
                    v-model="is_all_selected_available"
                    :disabled="remove_student_mode"
                  />
                  <span class="text-gray-500">{{
                    is_all_selected_available ? 'De-select All' : 'Select All'
                  }}</span>
                </div>
                <div
                  v-for="(user, index) in sorted_available_list"
                  :key="index"
                  class="flex flex-nowrap my-2"
                >
                  <pl-checkbox
                    @change="
                      handleSelectStudent($event, user.id || user.userId)
                    "
                    v-model="sorted_available_list[index].selected"
                    :disabled="remove_student_mode"
                  />
                  <span class="text-gray-500">{{
                    user.name || user.profile.name.fullName
                  }}</span>
                </div>
              </div>
              <button
                @click="
                  operation = 'invite';
                  finish();
                "
                class="px-8 py-2 mt-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50"
                :disabled="students_selected_for_invited.length === 0"
              >
                Invite
              </button>
            </div>
            <div class="flex flex-col">
              <p class="text-base text-black">Invited</p>
              <div
                v-if="!remove_student_mode"
                class="w-full h-80 p-3 border border-gray-100 rounded overflow-auto"
              >
                <div class="mb-2 bg-white border rounded border-gray-100">
                  <input
                    v-model="search_string_invited"
                    class="p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input"
                    type="text"
                    placeholder="Search..."
                  />
                </div>
                <div class="flex flex-nowrap" v-if="can_be_removed.length">
                  <pl-checkbox
                    @change="handleSelectAllInvited($event)"
                    v-model="is_all_selected_invited"
                    checkBoxClass="checkmark-red"
                    :disabled="remove_student_mode"
                  />
                  <span class="text-gray-500">
                    {{
                      is_all_selected_invited ? 'De-select All' : 'Select All'
                    }}
                  </span>
                </div>
                <div
                  v-for="(user, index) in sorted_invited_list"
                  :key="index"
                  class="flex flex-nowrap my-2"
                >
                  <pl-checkbox
                    @change="
                      handleSelectStudentUninvite(
                        $event,
                        user.id || user.userId
                      )
                    "
                    checkBoxClass="checkmark-red"
                    v-model="sorted_invited_list[index].selected"
                    :disabled="remove_student_mode"
                  />
                  <span class="text-gray-500">{{
                    user.name || user.profile.name.fullName
                  }}</span>
                </div>
              </div>
              <button
                @click="
                  operation = 'remove';
                  finish();
                "
                class="px-8 py-2 mt-2 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50"
                :disabled="students_selected_for_available.length === 0"
              >
                Remove
              </button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="flex m-0 w-full">
            <div class="flex flex-col col-md-student w-full">
              <p class="text-base text-black">Available</p>
              <div
                class="w-full h-80 max-h-80 p-3 border border-gray-100 rounded overflow-y-auto"
              >
                <div class="mb-2 bg-white border rounded border-gray-100">
                  <input
                    v-model="search_string_available"
                    class="p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input"
                    type="text"
                    placeholder="Search..."
                  />
                </div>
                <div v-if="students_to_import.length" class="flex flex-nowrap">
                  <pl-checkbox
                    @change="handleSelectAllAvailable($event)"
                    v-model="is_all_selected_available"
                    :disabled="remove_student_mode"
                  />
                  <span class="text-gray-500">
                    {{
                      is_all_selected_available ? 'De-select All' : 'Select All'
                    }}
                  </span>
                </div>
                <div
                  v-for="(user, index) in sorted_available_list"
                  :key="index"
                  class="flex flex-nowrap my-2"
                >
                  <pl-checkbox
                    @change="
                      handleSelectStudent($event, user.id || user.userId)
                    "
                    v-model="sorted_available_list[index].selected"
                    :disabled="remove_student_mode"
                  />
                  <span class="text-gray-500">
                    {{ user.name || user.profile.name.fullName }}
                  </span>
                </div>
              </div>
            </div>
            <div class="flex flex-col col-md-separator px-4 justify-center">
              <button
                @click="moveToInvited"
                :disabled="students_selected_for_invited.length === 0"
                class="bg-gray-200 my-2 text-center cursor-pointer disabled:opacity-50"
              >
                <i class="fas fa-angle-right text-2xl text-gray-500" />
              </button>
              <button
                @click="moveToAvailable"
                :disabled="students_selected_for_available.length === 0"
                class="bg-gray-200 my-2 text-center cursor-pointer disabled:opacity-50"
              >
                <i class="fas fa-angle-left text-2xl text-gray-500" />
              </button>
            </div>
            <div class="flex flex-col w-full col-md-student">
              <p class="text-base text-black">{{ inviteColumnName }}</p>
              <div
                v-if="!remove_student_mode"
                class="w-full h-80 max-h-80 p-3 border border-gray-100 rounded overflow-y-auto"
              >
                <div class="mb-2 bg-white border rounded border-gray-100">
                  <input
                    v-model="search_string_invited"
                    class="p-2 text-sm placeholder-gray-200 w-full text-gray-500 bg-input"
                    type="text"
                    placeholder="Search..."
                  />
                </div>
                <div class="flex flex-nowrap" v-if="can_be_removed.length">
                  <pl-checkbox
                    @change="handleSelectAllInvited($event)"
                    v-model="is_all_selected_invited"
                    :disabled="remove_student_mode"
                  />
                  <span class="text-gray-500">
                    {{
                      is_all_selected_invited ? 'De-select All' : 'Select All'
                    }}
                  </span>
                </div>
                <div
                  v-for="(user, index) in sorted_invited_list"
                  :key="index"
                  class="flex flex-nowrap my-2"
                >
                  <pl-checkbox
                    @change="
                      handleSelectStudentUninvite(
                        $event,
                        user.id || user.userId
                      )
                    "
                    v-model="sorted_invited_list[index].selected"
                    :disabled="remove_student_mode"
                  />
                  <span class="text-gray-500">
                    {{ user.name || user.profile.name.fullName }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
    <DisconnectAssignmentModal
      v-if="show_disconnect_integration_modal"
      :integrationToDisconnect="integration_connected"
      @close="show_disconnect_integration_modal = false"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import flatPickr from 'vue-flatpickr-component';
  import adminServices from 'services/admin/adminServices';
  import googleClassroomService from 'services/googleClassroom/googleClassroomServices';
  import { EventBus } from 'utils/event-bus';
  import urlConfigs from 'services/apiConfigs';
  import DisconnectAssignmentModal from 'components/modals/disconnectAssignmentModal';

  export default {
    data() {
      return {
        title: '',
        description: '',
        date: null,
        maxPoints: 100,
        students_tab: false,
        students: null,
        show_disconnect_integration_modal: false,
        search_string_available: '',
        search_string_invited: '',
        is_all_selected_uninvite: false,
        invited_students: [],
        is_all_selected_available: true,
        is_all_selected_invited: false,
        can_be_removed: [],
        students_to_import: [],
        students_imported: [],
        students_not_imported: [],
        students_to_remove: [],
        max_points_error_message:
          'Please input a number.\n Input 0 if you are not assessing.',
        schoology_categories: [],
        schoology_category: null,
        loading: false,
        config: {
          altFormat: 'F j, G:i K',
          altInput: true,
          enableTime: true,
          wrap: true,
          minDate: new Date(),
        },
        remove_student_mode: false,
        student_to_remove: {},
        edlink_course_students: [],
        google_classroom_course_students: [],
        show_message_error: false,
        show_no_students_message: false,
        link_to_RT: '',
        link_to_RT_html: '',
        operation: '',
      };
    },
    props: {
      activityType: {
        type: String,
        required: true,
      },
      logo: {
        type: String,
        required: true,
      },
      edLink: {
        type: Boolean,
        required: true,
      },
      selectedIntegration: {
        type: String,
        required: true,
      },
      selected_tab: {
        type: String,
        default: 'create_assignment_tab',
      },
    },
    components: {
      flatPickr,
      DisconnectAssignmentModal,
    },
    watch: {
      selected_tab: {
        immediate: true,
        async handler() {
          if (this.selected_tab === 'invite_students_tab' && !this.students) {
            await this.getStudentsOfCourse();
            this.handleSelectAllAvailable(true);
          }
        },
      },
      assignment_requirements: {
        immediate: true,
        handler() {
          this.$emit('nextStep', this.assignment_requirements);
        },
      },
      'sorted_available_list.length': {
        immediate: true,
        handler() {
          if (!this.courseWorkId)
            this.$emit(
              'finalStepEnabled',
              this.sorted_invited_list.length === 0
            );
        },
      },
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getCurrentRT',
        'getCurrentDiscussion',
      ]),
      inviteColumnName() {
        return this.courseWorkId ? 'Invited' : 'To be invited';
      },
      sorted_available_list() {
        const results = this.students_to_import.filter((x) => {
          return (x.name || x.profile.name.fullName)
            .toLowerCase()
            .includes(this.search_string_available.toLowerCase());
        });
        return results.sort((a, b) => {
          return (a.name || a.profile.name.fullName).localeCompare(
            b.name || b.profile.name.fullName
          );
        });
      },
      sorted_invited_list() {
        const results = this.can_be_removed.filter((x) =>
          (x.name || x.profile.name.fullName)
            .toLowerCase()
            .includes(this.search_string_invited.toLowerCase())
        );
        return results.sort((a, b) => {
          return (a.name || a.profile.name.fullName).localeCompare(
            b.name || b.profile.name.fullName
          );
        });
      },
      new_invited() {
        return this.courseWorkId
          ? this.students_selected_for_invited.map((s) => s.id || s.userId)
          : this.import_students_ids.filter(
              (id) =>
                !this.students_imported
                  .map((s) => s.id || s.userId)
                  .includes(id)
            );
      },
      new_deleted() {
        return this.courseWorkId
          ? this.students_selected_for_available.map((s) => s.id || s.userId)
          : this.not_import_students_ids.filter((id) =>
              this.students_imported.map((s) => s.id || s.userId).includes(id)
            );
      },
      max_points_error() {
        return this.maxPoints === '';
      },
      assignment_requirements() {
        return this.title.trim().length > 0 && !this.max_points_error;
      },
      students_selected_for_available() {
        return this.sorted_invited_list.filter((s) => s.selected === true);
      },
      students_selected_for_invited() {
        return this.sorted_available_list.filter((s) => s.selected === true);
      },
      students_can_import() {
        if (this.can_be_removed.length) {
          return this.students.filter((s) => {
            const ids = this.can_be_removed.map((u) => u.userId || u.id);
            return !ids.includes(s.userId || s.id);
          });
        }
        return this.students;
      },
      import_students_ids() {
        return this.courseWorkId
          ? this.students_selected_for_invited.map((s) => s.id || s.userId)
          : this.sorted_invited_list.map((s) => s.id || s.userId);
      },
      not_import_students_ids() {
        return this.courseWorkId
          ? this.students_selected_for_available.map((s) => s.id || s.userId)
          : this.sorted_available_list.map((s) => s.id || s.userId);
      },
      can_be_removed_ids() {
        return this.can_be_removed.map((s) => s.id || s.userId);
      },
      course_subscriptions_ids() {
        return this.getCourseDetail.users.map(
          (u) => u.subscription.google_classroom_integration.user_id
        );
      },
      all_edlink_course_students() {
        return (
          this.getListInvited().length === this.edlink_course_students.length
        );
      },
      all_google_classroom_course_students() {
        return (
          this.getListInvited().length ===
          this.google_classroom_course_students.length
        );
      },
      integration() {
        return this.edLink
          ? this.getCourseDetail.edlink_integrations.find(
              (x) =>
                x.provider_name.toLowerCase() ===
                this.selectedIntegration.toLowerCase()
            )
          : null;
      },
      header() {
        return this.selected_tab === 'create_assignment_tab'
          ? 'Create Assignment'
          : 'Select Students';
      },
      currentActivity() {
        if (this.activityType === 'written') {
          return this.getCurrentRT;
        }
        return this.getCurrentDiscussion;
      },
      courseWorkId() {
        if (this.edLink) {
          const integration = this.currentActivity.edlink_integrations.find(
            (ed) =>
              ed.provider_name.toLowerCase() ===
              this.selectedIntegration.toLowerCase()
          );
          return integration ? integration.assignment_id : null;
        }
        if (
          this.$route.params.roundtableID ||
          this.$route.params.liveDiscussionID
        ) {
          return this.currentActivity.google_classroom_course_work_id;
        }
        return null;
      },
      assigmentDate() {
        if (this.date) {
          return new Date(this.date);
        }
        return null;
      },
      activityID() {
        return this.currentActivity ? this.currentActivity.id : null;
      },
      magicLink() {
        const urlBase = `${urlConfigs.uiURL}?invite_code=`;
        const { currentActivity, formatParam, doubleFormatParam } = this;
        const invite_code =
          currentActivity.invites && currentActivity.invites.length > 0
            ? currentActivity.invites[0].code
            : '';
        return {
          normal: `${urlBase}${formatParam(invite_code)}`,
          double_formatted: `${urlBase}${doubleFormatParam(invite_code)}`,
          invite_code,
        };
      },
      integration_connected() {
        let integration_connected = {};
        if (this.selectedIntegration !== 'Google Classroom') {
          integration_connected = this.getCourseDetail.edlink_integrations.find(
            (integration) =>
              integration.provider_name === this.selectedIntegration
          );
        } else {
          integration_connected =
            this.getCourseDetail.google_classroom_integration;
          integration_connected.provider_name = 'Google Classroom';
          integration_connected.provider_icon_url =
            '/static/admin_icons/google-classroom.png';
        }
        return integration_connected;
      },
    },
    methods: {
      inputed() {
        if (this.maxPoints === '.') {
          this.maxPoints = '';
        }
        if (isNaN(this.maxPoints)) {
          this.maxPoints = this.maxPoints.slice(0, -1);
        } else {
          this.maxPoints = this.maxPoints.trim();
        }
        if (this.maxPoints < 0) {
          this.maxPoints = 0;
        }
      },
      disconnectIntegration() {
        this.show_disconnect_integration_modal = true;
      },
      nextStep() {
        if (this.assignment_requirements && !this.loading) {
          this.students_tab = true;
        }
      },
      previousStep() {
        if (!this.loading) {
          this.students_tab = false;
        }
      },
      moveToInvited() {
        const user_ids = this.students_selected_for_invited.map(
          (s) => s.userId || s.id
        );
        this.can_be_removed = [
          ...this.can_be_removed,
          ...this.students_selected_for_invited.map((s) =>
            s.selected === true ? { ...s, selected: false } : s
          ),
        ];
        this.students_to_import = this.students_to_import.filter(
          (a) => !user_ids.includes(a.userId || a.id)
        );
        this.is_all_selected_invited = false;
      },
      moveToAvailable() {
        const user_ids = this.students_selected_for_available.map(
          (s) => s.userId || s.id
        );
        this.students_to_import = [
          ...this.students_to_import,
          ...this.students_selected_for_available.map((s) =>
            s.selected === true ? { ...s, selected: false } : s
          ),
        ];
        this.can_be_removed = this.can_be_removed.filter(
          (a) => !user_ids.includes(a.userId || a.id)
        );
        this.is_all_selected_available = false;
      },
      handleSelectAllAvailable(status) {
        this.sorted_available_list.map((s) => {
          this.$set(s, 'selected', status);
        });
        this.is_all_selected_available = status;
      },
      handleSelectAllInvited(status) {
        this.sorted_invited_list.map((s) => {
          this.$set(s, 'selected', status);
        });
        this.is_all_selected_invited = status;
      },
      handleSelectStudent(status, id) {
        const index = this.sorted_available_list.findIndex(
          (s) => (s.id || s.userId) === id
        );
        if (index > -1) {
          const selected = ['on', true].includes(status) ? true : false;
          this.$set(this.sorted_available_list[index], 'selected', selected);
          const is_selected = this.sorted_available_list.filter(
            (s) => s.selected === true
          );
          this.is_all_selected_available =
            is_selected.length === this.sorted_available_list.length;
        }
      },
      handleSelectStudentUninvite(status, id) {
        const index = this.sorted_invited_list.findIndex(
          (s) => (s.id || s.userId) === id
        );
        if (index > -1) {
          const selected = ['on', true].includes(status) ? true : false;
          this.$set(this.sorted_invited_list[index], 'selected', selected);
          const is_selected = this.sorted_invited_list.filter(
            (s) => s.selected === true
          );
          this.is_all_selected_invited =
            is_selected.length === this.sorted_invited_list.length;
        }
      },
      async getStudentsOfCourse() {
        this.loading = true;
        if (this.edLink) {
          await this.getEdlinkStudentsOfCourse();
        } else {
          await this.getGoogleStudentsOfCourse();
        }
        this.loading = false;
      },

      changeAssigmentStudents() {
        if (this.edLink) {
          return this.changeEdlinkAssigmentStudents();
        }
        return this.changeGoogleAssigmentStudents();
      },

      createAssignment() {
        if (this.edLink) {
          return this.createEdlinkAssignment();
        }
        return this.createGoogleAssignment();
      },

      getGoogleStudentsOfCourse() {
        return googleClassroomService
          .getGoogleClassroomCourseStudents(
            this.getCourseDetail.id,
            this.getCourseDetail.google_classroom_integration.course_id
          )
          .then(async ({ data }) => {
            this.students = data.students;
            this.google_classroom_course_students = data.students;
            this.students = this.students.filter((s) =>
              this.course_subscriptions_ids.includes(s.userId)
            );
            /* Assignment feito */
            if (this.courseWorkId) {
              const { data } = await this.getStudentsOfCourseWork();
              const submissions = data.studentSubmissions;
              const submissions_users_ids = submissions.map((s) => s.userId);
              this.can_be_removed = this.students.filter((s) =>
                submissions_users_ids.includes(s.userId)
              );
            }
            this.students_tab = true;

            this.students_to_import = this.students_can_import.map((s) => {
              return s;
            });

            this.students_imported = this.can_be_removed.slice();
            this.students_not_imported = this.students_can_import.slice();
            this.students_to_import.forEach((s) => {
              this.$set(s, 'selected', false);
            });
            return data.students;
          })
          .catch((err) => {
            const message = err.response.data.error;
            if (message) {
              this.createToast(message, 'Error');
            }
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      getStudentsOfCourseWork() {
        return googleClassroomService
          .getGoogleClassroomAssignmentSubmissions(
            this.getCourseDetail.id,
            this.getCourseDetail.google_classroom_integration.course_id,
            this.activityType,
            this.activityID,
            this.courseWorkId
          )
          .catch((err) => {
            this.loading = false;
            this.show_message_error = true;
            console.error(err);
          });
      },

      getEdlinkStudentsOfCourse() {
        const { id: integration_id, course_id: edlink_course_id } =
          this.integration;

        const parlay_students =
          this.activityType === 'written'
            ? this.currentActivity.submissions
            : this.currentActivity.participations;

        const students_emails = parlay_students.map((s) => s.user.email);

        return adminServices
          .getAvailableAssignmentsStudents(
            this.getCourseDetail.id,
            integration_id,
            edlink_course_id
          )
          .then((res) => {
            this.students = res.data.imported_course_integration_students;
            this.edlink_course_students = res.data.edlink_course_students;
            this.students_tab = true;
            this.can_be_removed = this.students.filter((s) =>
              students_emails.includes(s.email)
            );

            //set for reactivity
            this.students_to_import = this.students_can_import.map((s) => {
              return s;
            });

            this.students_to_import.forEach((s) => {
              this.$set(s, 'selected', false);
            });

            this.students_imported = this.can_be_removed.slice();
            this.students_not_imported = this.students_can_import.slice();

            if (res.data.edlink_course_students.length === 0) {
              this.show_no_students_message = true;
            }
            return res;
          })
          .catch((err) => {
            console.error(err);
            this.loading = false;
            this.show_message_error = true;
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async changeGoogleAssigmentStudents() {
        const payload = {};
        // only send emails of students that changed from not invited to invited or vice-versa

        const new_deleted = this.operation === 'invite' ? [] : this.new_deleted;
        const new_invited = this.operation === 'remove' ? [] : this.new_invited;
        const changed_students = new_deleted.concat(new_invited);

        const students_emails = this.students
          .filter((s) => changed_students.includes(s.userId))
          .map((s) => s.profile.emailAddress);

        const addStudentIds = this.getListInvited().map(
          (s) => s.userId || s.id
        );

        if (!this.all_google_classroom_course_students) {
          payload.modifyIndividualStudentsOptions = {
            addStudentIds,
            removeStudentIds: new_deleted,
          };
          payload.assigneeMode = 'INDIVIDUAL_STUDENTS';
        } else {
          payload.assigneeMode = 'ALL_STUDENTS';
        }
        payload.students_emails = students_emails;

        if (addStudentIds.length > 0) {
          return googleClassroomService
            .updateGoogleClassroomCourseAssignment(
              this.getCourseDetail.id,
              this.getCourseDetail.google_classroom_integration.course_id,
              this.activityType,
              this.activityID,
              this.courseWorkId,
              payload
            )
            .then(({ data }) => {
              this.createToast('Assignment updated with success', 'Success');
              const action =
                this.activityType === 'written'
                  ? 'fetchRoundtable'
                  : 'fetchLiveDiscussion';
              this.$store.dispatch(action, this.activityID);
              return data;
            })
            .catch((error) => {
              this.createToast(error.response.data.message, 'Error');
            })
            .finally(() => {
              this.loading = false;
              this.operation = '';
            });
        } else {
          this.createToast(
            'You must have at least one student in a RoundTable that is connected to an assignment in an external LMS. Add new students or disconnect the assignment.',
            'Warning'
          );
        }
      },
      getListInvited() {
        if (this.courseWorkId) {
          if (this.operation === 'remove')
            return this.students_imported.filter(
              (s) => !this.new_deleted.includes(s.id || s.userId)
            );
          if (this.operation === 'invite')
            return this.students_imported.concat(
              this.students_selected_for_invited
            );
        }
        return this.sorted_invited_list.map((s) => s.userId || s.id);
      },
      changeEdlinkAssigmentStudents() {
        const { id: integration_id, course_id: edlink_course_id } =
          this.integration;

        let students = this.getListInvited().map((s) => s.userId || s.id);

        const new_deleted = this.operation === 'invite' ? [] : this.new_deleted;
        const new_invited = this.operation === 'remove' ? [] : this.new_invited;

        const changed_students = new_deleted + new_invited;
        const students_emails = this.students
          .filter((s) => changed_students.includes(s.id))
          .map((s) => s.email);

        const personalized = !this.all_edlink_course_students;

        if (students.length === 0) {
          this.createToast(
            'You must have at least one student in a RoundTable that is connected to an assignment in an external LMS. Add new students or disconnect the assignment.',
            'Warning'
          );
        } else {
          // :TODO
          // review title shouldn't be needed but is required by the Edlink endpoint
          // hardcoded for now with Parlay activity name
          const payload = {
            title: this.currentActivity.title,
            students,
            personalized,
            students_emails,
            provider_name:
              this.selectedIntegration.charAt(0).toUpperCase() +
              this.selectedIntegration.slice(1),
          };

          return this.$store
            .dispatch('updateSsoCourseAssignment', {
              course_id: this.getCourseDetail.id,
              integration_id,
              edlink_course_id,
              activity_type: this.activityType,
              activity_id: this.activityID,
              assignment_id: this.courseWorkId,
              payload,
            })
            .then(async (data) => {
              this.createToast('Assignment updated with success', 'Success');
              if (data) {
                const action =
                  this.activityType === 'written'
                    ? 'fetchRoundtable'
                    : 'fetchLiveDiscussion';

                await this.$store.dispatch(action, this.activityID);
              } else {
                this.createToast(
                  'There was an error updating the assignment or the assignment has been deleted.',
                  'Error'
                );
              }
              return data;
            })
            .catch(() => {
              this.createToast(
                'There was an error updating the assignment or the assignment has been deleted.',
                'Error'
              );
            })
            .finally(() => {
              this.operation = '';
            });
        }
      },
      createGoogleAssignment: async function () {
        const students_to_add = this.can_be_removed_ids;

        const students_emails = this.students
          .filter((s) => students_to_add.includes(s.userId))
          .map((s) => s.profile.emailAddress);

        const payload = {
          title: this.title,
          description: this.description.concat('\n', this.link_to_RT),
          maxPoints: this.maxPoints,
          workType: 'ASSIGNMENT',
          associatedWithDeveloper: true,
          state: 'PUBLISHED',
          students_emails,
        };

        if (this.date) {
          payload.dueDate = {
            day: this.assigmentDate.getDate(),
            month: this.assigmentDate.getMonth() + 1,
            year: this.assigmentDate.getFullYear(),
          };
          payload.dueTime = {
            hours: this.assigmentDate.getHours(), // change cause of AM/PM
            minutes: this.assigmentDate.getMinutes(),
          };
        }

        const assigneeMode = this.all_google_classroom_course_students
          ? 'ALL_STUDENTS'
          : 'INDIVIDUAL_STUDENTS';

        if (!this.all_google_classroom_course_students) {
          payload.individualStudentsOptions = {};
          payload.individualStudentsOptions.studentIds = students_to_add;
        }
        payload.assigneeMode = assigneeMode; //'INDIVIDUAL_STUDENTS';

        if (this.import_students_ids.length === 0) {
          this.createToast(
            'You must have at least one student in a RoundTable that is connected to an assignment in an external LMS. Add new students or disconnect the assignment.',
            'Warning'
          );
        } else {
          try {
            const createAssignment =
              await googleClassroomService.createGoogleClassroomCourseAssignment(
                this.getCourseDetail.id,
                this.getCourseDetail.google_classroom_integration.course_id,
                this.activityType,
                this.activityID,
                payload
              );
            const { data } = createAssignment;
            this.$emit('close');
            this.createToast('Assignment created with success!', 'Success');

            if (this.activityType === 'written') {
              await this.$store.dispatch(
                'fetchCourseDetails',
                this.$route.params.courseID
              );
              await this.$store.dispatch('fetchRoundtable', this.activityID);
            }

            if (this.activityType === 'verbal') {
              await this.$store.dispatch(
                'fetchCourseDetails',
                this.$route.params.courseID
              );
              await this.$store.dispatch(
                'fetchLiveDiscussion',
                this.activityID
              );
            }

            return data;
          } catch (error) {
            if (error.response.status === 500) {
              this.createToast(
                'Something as happened... Try again and check your connection',
                'Error'
              );
              return;
            }
            this.createToast(error.response.data.message, 'Error');
            return;
          }

          /* return googleClassroomService
            .createGoogleClassroomCourseAssignment(
              this.getCourseDetail.id,
              this.getCourseDetail.google_classroom_integration.course_id,
              this.activityType,
              this.activityID,
              payload
            )
            .then((res, { data }) => {
              this.createToast('Assignment created with success!', 'Success');
              this.$emit('close');
              const action =
                this.activityType === 'written'
                  ? 'fetchRoundtable'
                  : 'fetchLiveDiscussion';
              this.$store.dispatch(action, this.activityID);
              return data;
            })
            .catch((error) => {
              if(error === null || error === undefined || error === ''){
                this.createToast('Something Happen... Try again and check your connection', 'Error');
                return;
              }
              //show error to the user that comes from google api
              this.createToast(error.response.data.message, 'Error');
              return;
            }); */
        }
      },
      createToast(message, type) {
        const toast = {
          type,
          message,
          time: 5000,
        };
        EventBus.$emit('createToast', toast);
      },
      createEdlinkAssignment() {
        const { id: integration_id, course_id: edlink_course_id } =
          this.integration;

        const students_to_add = this.can_be_removed_ids;

        const students_emails = this.students
          .filter((s) => students_to_add.includes(s.id))
          .map((s) => s.email);

        const personalized = !this.all_edlink_course_students;

        const payload = {
          title: this.title,
          description: this.description.concat(this.link_to_RT_html),
          points_possible: this.maxPoints,
          due_date: this.assigmentDate,
          students: students_to_add,
          personalized,
          students_emails,
          provider_name:
            this.selectedIntegration.charAt(0).toUpperCase() +
            this.selectedIntegration.slice(1),
          submission_types: ['text'], // it's necessary for canvas integration
        };

        if (this.schoology_category && this.schoology_category.id) {
          payload.grading_category = this.schoology_category.id;
        }
        if (students_to_add.length === 0) {
          this.createToast(
            'You must have at least one student in a RoundTable that is connected to an assignment in an external LMS. Add new students or disconnect the assignment.',
            'Warning'
          );
        } else {
          return this.$store
            .dispatch('createSsoCourseAssignment', {
              course_id: this.getCourseDetail.id,
              integration_id,
              edlink_course_id,
              activity_type: this.activityType,
              activity_id: this.activityID,
              payload,
            })
            .then(async (data) => {
              if (data) {
                this.createToast('Assignment created with success!', 'Success');
                const action =
                  this.activityType === 'written'
                    ? 'fetchRoundtable'
                    : 'fetchLiveDiscussion';
                await this.$store.dispatch(action, this.activityID);
                this.$emit('close');
                return data;
              }
            });
        }
      },

      async finish() {
        this.loading = true;
        // assigment created change student list
        if (this.courseWorkId) {
          await this.changeAssigmentStudents();
        } else {
          await this.createAssignment();
        }
        this.loading = false;
      },

      prepareStudentDeletion(s, index) {
        this.can_be_removed.splice(index, 1);
        this.$set(s, 'selected', false);
        this.is_all_selected_available = false;
        this.students_to_import.push(s);
      },

      doubleFormatParam(param) {
        return this.formatParam(this.formatParam(param));
      },
      formatParam(param) {
        // Replace special characters with correct encoding to safely read URL
        return (
          param
            // /g performs a global replace on the string insted of just the first_name
            // character that matches
            .replace(/%/g, '%25')
            .replace(/ /g, '%20')
            .replace(/\$/g, '%24')
            .replace(/#/g, '%23')
        );
      },
    },
    async created() {
      if (this.courseWorkId !== null) {
        this.$emit('selectedTab', 'invite_students_tab');
      }
      if (
        this.edLink &&
        this.integration.provider_name === 'Schoology' &&
        !this.students_tab
      ) {
        const payload = {
          integration_id: this.integration.id,
          edlink_course_id: this.integration.course_id,
          course_id: this.getCourseDetail.id,
        };
        this.schoology_categories = await this.$store.dispatch(
          'getCourseCategories',
          payload
        );
        /* if (this.schoology_categories.length) {
          this.schoology_category = this.schoology_categories[0];
        } */
      }
    },
    mounted() {
      this.title = this.currentActivity.title;
      this.date = this.currentActivity.end_date
        ? this.currentActivity.end_date
        : null;

      this.link_to_RT = `Please click on the link below to join the Parlay activity:\n\n ${this.magicLink.normal} `;
      this.link_to_RT_html = `<div>Please click on the link below to join the Parlay activity:</div>
        <a class="hover:underline" href="${this.magicLink.normal}"
        <span style="font-weight:bold"> ${this.magicLink.normal} </span>
        </a>
        `;
    },
  };
</script>



// WEBPACK FOOTER //
// integrationsAssignmentModal.vue?2982818c